import { render } from "./util.vue?vue&type=template&id=5ddbfe9a&scoped=true"
import script from "./util.vue?vue&type=script&lang=js"
export * from "./util.vue?vue&type=script&lang=js"

import "./util.vue?vue&type=style&index=0&id=5ddbfe9a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\NASTYFACT\\Desktop\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ddbfe9a"]])

export default __exports__